export enum TriggerScenario {
    FIRST_TIME = 'FIRST_TIME',
    INTENSIVE_SCROLLING = 'INTENSIVE_SCROLLING',
    MANUALLY = 'MANUALLY',
}
